import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-simple-create",
  "use": "app-icon-simple-create-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-simple-create\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M8 .5a7.5 7.5 0 110 15 7.5 7.5 0 010-15zm0 1a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM8 4a.5.5 0 01.5.5v3h3a.5.5 0 110 1h-3v3a.5.5 0 11-1 0v-3h-3a.5.5 0 010-1h3v-3A.5.5 0 018 4z\" fill=\"#2673E5\" fill-rule=\"nonzero\" /><path d=\"M0 0h16v16H0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol